import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { CombinedCalendarStore } from '../store/combined-calendar-store';
import { UntypedFormBuilder, UntypedFormGroup, ReactiveFormsModule } from '@angular/forms';
import { ActivatedRoute, Params, Router } from '@angular/router';
import { ConfigService } from '../../../shared/services/config.service';
import { MatCheckbox } from '@angular/material/checkbox';
import { NgFor, NgIf, AsyncPipe } from '@angular/common';
import { MatOption } from '@angular/material/core';
import { MatSelect } from '@angular/material/select';
import { MatFormField } from '@angular/material/form-field';
import { MatRadioGroup, MatRadioButton } from '@angular/material/radio';
import { MatIcon } from '@angular/material/icon';
import { MatIconButton } from '@angular/material/button';

@Component({
    selector: 'app-calendar-filter',
    templateUrl: './calendar-filter.component.html',
    styleUrls: ['./calendar-filter.component.css'],
    standalone: true,
    imports: [MatIconButton, MatIcon, ReactiveFormsModule, MatRadioGroup, MatRadioButton, MatFormField, MatSelect, MatOption, NgFor, NgIf, MatCheckbox, AsyncPipe]
})
export class CalendarFilterComponent implements OnInit {
  filterForm: UntypedFormGroup;
  categories$ = this.combinedCalendarStore.categories$;
  locations$ = this.configService.locations;

  @Output()
  closePressed = new EventEmitter<void>();

  constructor(
    private fb: UntypedFormBuilder,
    private readonly combinedCalendarStore: CombinedCalendarStore,
    private configService: ConfigService,
    private route: ActivatedRoute,
    private router: Router
  ) {
    this.filterForm = fb.group({
      category: fb.control(null),
      mode: fb.control('all'),
      location: fb.control(null),
      available: fb.control(true),
      hires: fb.control(true),
      bookings: fb.control(true),
      overdueOnly: fb.control(false),
      product: fb.control(null)
    });
  }

  ngOnInit() {
    this.setInitialFormValueBasedOnRoute();
    this.updateRouteOnFilter();
    this.updateStoreOnRouteChanges();
  }

  private setInitialFormValueBasedOnRoute() {
    this.filterForm.setValue(
      this.queryParamsToFilter(this.route.snapshot.queryParams)
    );
  }

  private updateRouteOnFilter() {
    this.filterForm.valueChanges.subscribe({
      next: (value) =>
        this.router.navigate([], {
          relativeTo: this.route,
          queryParams: value,
          queryParamsHandling: 'merge'
        })
    });
  }

  private updateStoreOnRouteChanges() {
    this.route.queryParams.subscribe((params) => {
      this.combinedCalendarStore.setFilter(this.queryParamsToFilter(params));
    });
  }

  private queryParamsToFilter(params: Params) {
    return {
      category: params['category'] ? parseInt(params['category'], 10) : null,
      mode: params['mode'] ?? 'all',
      location: params['location'] ? parseInt(params['location'], 10) : null,
      overdueOnly:
        params['overdueOnly'] === undefined
          ? false
          : params['overdueOnly'] === 'true',
      available: params['available'] !== 'false',
      hires: params['hires'] !== 'false',
      bookings: params['bookings'] !== 'false',
      product: null
    };
  }
}
